import { CommanServices } from "@/services/commanServices";
import { parseTimestamp } from "@/uitilites/utility";

let inflightPromise = null;

export function getInflightDutyCheckPromise() {
    return inflightPromise;
}

export function runDutyCheckRequest(payload) {
    if (inflightPromise) {
        return inflightPromise;
    }

    inflightPromise = CommanServices.sendDutyCheck(payload)
        .then((res) => {
            inflightPromise = null;
            return res;
        })
        .catch((err) => {
            inflightPromise = null;
            throw err;
        });

    return inflightPromise;
}

export async function recoverDutyCheckJob(startedAt) {
    try {
        const res = await CommanServices.getLatestDutyCheck();
        if (!res?.status || !res?.data?.created_at) {
            return null;
        }
        const created = parseTimestamp(res.data.created_at)?.getTime();
        if (!created) return null;
        if (created >= startedAt - 3000) {
            return {
                success: true,
                message: "Duty check initiated!",
                data: res.data,
            };
        }
    } catch {
        /* ignore */
    }
    return null;
}
